module.exports = __webpack_public_path__ + "static/9-66e01787d576f11801400c9b6e5d22a4.jpg";